import React from 'react';
import { IonApp } from '@ionic/react';
import { IonAppProps } from '../../common/components.types';

export const AllieApp: React.FC<IonAppProps> = (props) => {
  return <IonApp {...props} />;
};
